import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';
import type { AxiosResponse } from 'axios';

export interface SuggestCommentRequest {
  postId: number;
  agentUserId: number;
}

export interface SuggestCommentResponse {
  statusCode?: number;
  success?: boolean;
  message?: string;
  postCommentId?: number;
  commentText?: string;
}

export interface AgentsListRequest {
  timezoneOffset: number;
  isActive: boolean;
  pageNumber?: number;
  pageSize: number;
}

const agentApi = {
  /**
   * POST /api/v1/Agent/AgentsList
   * Retrieves a list of AI Buddies based on timezone.
   */
  agentsList: (payload: AgentsListRequest): Promise<AxiosResponse<any>> =>
    apiClient.post<any>(API_ENDPOINTS.AGENT.AGENTS_LIST, payload),

  /**
   * GET /api/v1/Agent/AiBuddySettings
   * Fetches settings for the specified AI Buddy.
   */
  getAiBuddySettings: (agentUserId: number): Promise<AxiosResponse<any>> =>
    apiClient.get<any>(API_ENDPOINTS.AGENT.AI_BUDDY_SETTINGS, { params: { agentUserId } }),

  /**
   * POST /api/v1/Agent/AiBuddySettings
   * Saves settings for the specified AI Buddy.
   */
  saveAiBuddySettings: (payload: {
    agentUserId: number;
    keepHistoryFor30Days: boolean;
    enableSuggestLikes: boolean;
    enableSuggestComments: boolean;
  }): Promise<AxiosResponse<any>> =>
    apiClient.post<any>(API_ENDPOINTS.AGENT.AI_BUDDY_SETTINGS, payload),

  /**
   * POST /api/v1/Agent/SuggestComment
   * Generates and posts an AI buddy comment on the authenticated user's own post.
   */
  suggestComment: (
    payload: SuggestCommentRequest,
  ): Promise<AxiosResponse<SuggestCommentResponse>> =>
    apiClient.post<SuggestCommentResponse>(
      API_ENDPOINTS.AGENT.SUGGEST_COMMENT,
      payload,
    ),
};

export default agentApi;
